import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { api } from '../../@common';

export const useForgotPassword = () => {
  const forgotPassword = useMutation({
    mutationFn: async (email: string) => {
      return await api.post('/auth/forgot-password', { email });
    },
    onSuccess: () => {
      message.success('If that email exists, you will receive instructions to reset your password', 5);
    },
    onError: () => {
      message.error('Failed to request a password reset');
    },
  });

  return {
    forgotPassword,
    isLoading: forgotPassword.isPending,
    isSuccess: forgotPassword.isSuccess,
  };
};
